import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import { urlParams, getPageLayoutType, decode_utf8, getSignedIdStatus, transformId } from '../../../../common/utils/utilsFunc'
import SubscriptionsContextProvider, { ACTIONS, SubscriptionsContext } from '../../context/SubscriptionsContextProvider';
import AlertModal from "../../../../common/components/AlertModal";
import { useModal } from "@clayui/modal";
import Loading from "../../../../common/components/Loading";
import "../../styles/index.scss";
import { TOKEN_CAPTCHA_COOKIE_KEY } from "../../../../common/utils/cookiesUtil";
import useCookie from '../../../../common/hooks/useCookie';

function AnulationSubscription({ props }) {
    const [state, dispatch] = React.useContext(SubscriptionsContext)
    const [verifReCaptcha, setVerifReCaptcha] = React.useState(false);
    const [visibleModal, setVisibleModal] = React.useState(false);
    const [loading, setLoading] = React.useState(false)
    const [msgModalReturn, setMsgModalReturn] = React.useState(false);
    const [visibleModalReturn, setVisibleModalReturn] = React.useState(false);
    const [errorCli, setErrorCli] = React.useState(false);
    const { observer, onClose } = useModal({
        onClose: () => {
            setVisibleModal(false);
            setVisibleModalReturn(false);
        },
    });
    const [values, setValues] = React.useState({
        idClient: '',
        canal: ''
    })
    const [inputValidate, setInputValidate] = React.useState({
        empty: {},
        validated: {},
        msg: {}
    });
    const { updateCookieState } = useCookie(TOKEN_CAPTCHA_COOKIE_KEY);

    let propsLabelInfoContent = {
        "setVisibleModal": setVisibleModal,
        "observer": observer,
        "onClose": onClose,
        "visibleModal": visibleModal,
        "titleModal": "Información",
        "status": "info",
        "content": state?.webContentTextInfo,
        "titleHint": "Ayuda Nro de Cliente",
    }

    function setInitialStateForms() {
        setValues({
            idClient: getPageLayoutType() ? values.idClient : '',
        })

        setInputValidate({
            empty: {},
            error: {},
            msg: {}
        });
    }

    React.useEffect(() => {
        let canal = urlParams.get('canal')
        let ctacto = urlParams.get('ctacto')
        if (canal) {
            setValues({ ...values, canal: canal, idClient: ctacto })
        } else if (getPageLayoutType()) {
            setValues({ ...values, canal: "OV", idClient: ctacto })
        } else if (!getPageLayoutType()) {
            setValues({ ...values, canal: "URL", idClient: ctacto })
        } else {
            setValues({ ...values, canal: "", idClient: ctacto })
        }
    }, [])

    function handleClickButtonClient() {
        if (values.idClient) {
            setErrorCli(false);
            props.setIdClient(values.idClient)
        } else {
            setErrorCli(true);
        }
    }

    function onChangeReCaptcha(value) {
        updateCookieState(value);
        if (value) {
            setVerifReCaptcha(true);
        }
        else {
            setVerifReCaptcha(false);
        }
    }

    function funcClickBack() {
        window.location.href = getPageLayoutType() ? `/group/guest/suscripciones` : '/servicios-en-linea'
    }

    function funcValidate() {
        let errors = {
            empty: {},
            validated: {},
            msg: {}
        };

        if (values.idClient) {
            errors.empty.idClient = false;
        } else {
            errors.empty.idClient = true;
            errors.msg.idClient = "Debe ingresar un Nro de Cliente"
        }

        setInputValidate(errors)
        return errors
    }

    function funcClick() {
        const objErros = funcValidate();
        if (Object.values(objErros?.msg).length > 0) {
            props.setGlobalAlert("Complete todos los campos obligatorios", "warning");
        } else if (!verifReCaptcha && !getPageLayoutType()) {
            props.setGlobalAlert("Falta validar que no eres un Robot.", "warning");

        } else if ((transformId(props.state?.idClientAux) !== transformId(values.idClient)) && !getPageLayoutType()) {
            props.setGlobalAlert("Debes realizar la búsqueda del número de cliente.","warning");
        } else {
            let json = {
                "nroCliente": values.idClient,
                "empresa": props.codigo_empresa,
                "url": props.url_ws_empresa,
                "canal": values.canal,
                "signedIn": getSignedIdStatus(),
                "claveParam": props.claveParam? props.claveParam : ''
            }
            setLoading(true)
            dispatch({
                type: ACTIONS.SET_JSON_ANULATION_SUBSCRIPTION,
                payload: json

            })

        }

    }

    React.useEffect(() => {
        if (state.responseAnulationSubscription) {
            setLoading(false)
            if (state.responseAnulationSubscription?.code || state.responseAnulationSubscription?.code === 0) {
                if (state.responseAnulationSubscription?.code === 0) {
                    setVisibleModalReturn(true)
                    setMsgModalReturn(state.responseAnulationSubscription?.message)
                    if(props?.detailClientJson?.COMUNA) {
                        props?.setDetailClientJson([]);
                    }
                } else {
                    props.setGlobalAlert(state.responseAnulationSubscription?.message, "warning", true, "Advertencia");
                }

            } else {
                props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
            }
            setInitialStateForms();
        }

    }, [state.responseAnulationSubscription])

    return (
        <CGE.Panel title={decode_utf8(props.title_anulation_subscription)} description={getPageLayoutType() ? decode_utf8(props.description_modification_anulation_subscription) : decode_utf8(props.description_anulation_pub)}>
            <div className="row">
                <div className="col-md-12">
                    <CGE.DetailClient
                        props={{
                            handleChange: (e) => {
                                setValues({ ...values, idClient: e.target.value });
                                props.setDetailClientJson([]);
                            },
                            handleClick: () => { handleClickButtonClient() },
                            hasError: errorCli || inputValidate?.empty?.idClient,
                            msgError: "Debe ingresar un Nro de Cliente",
                            idClient: values.idClient,
                            idFormElement: "inputNumClient",
                            labelButton: "Buscar",
                            labelName: "Número de Cliente",
                            mandatoryElement: true,
                            readOnly: getPageLayoutType() ? true : false,
                            sizeButton: "sm",
                            typeButton: "primary",
                            typeFormElement: "text",
                            typeElement:"input-mask",
                            maxLength:"12",
                            formatChars:{
                                9: "[0-9]"
                            },
                            mask:"999999999999",
                            valuePriv: values.idClient,
                            propsLabelInfoContent:propsLabelInfoContent
                            
                        }}
                        propsDetail={{
                            fullNameClient: "",
                            comunaClient: props.detailClientJson?.COMUNA ? props.detailClientJson?.COMUNA : "",
                            calleClient: props.detailClientJson?.CALLE ? props.detailClientJson?.CALLE : "",
                            nCalleClient: props.detailClientJson?.NUMERO_CASA ? props.detailClientJson?.NUMERO_CASA : "",
                            dptoBlockClient: (props.detailClientJson?.SUPLEMENTO || props.detailClientJson?.PISO) ? `${props.detailClientJson?.SUPLEMENTO} 
                        ${props.detailClientJson?.PISO}` : "",
                            ctaCtoClient: props.detailClientJson?.CTA_CTO
                        }}
                    />
                </div>
                {!getPageLayoutType() &&
                    <div className="col-md-12">
                        <CGE.FieldRecaptcha
                            onChange={onChangeReCaptcha}
                            sitekey={props.api_key_recaptcha}
                        />
                    </div>
                }
                <div class="col-md-12">
                    <CGE.RenderContent textContent={state?.webContentAnulationSubscriptionTextInfo} />
                </div>
                <div class="col-md-12">
                    <div className="d-flex justify-content-between">
                        <CGE.Button
                            className="mr-3"
                            label="Volver"
                            onClick={() => funcClickBack()}
                            type="secondary"
                        />
                        <CGE.Button
                            label="Aceptar"
                            onClick={() => funcClick()}
                        />
                    </div>
                </div>
            </div>
    
            {loading && <Loading />}
            {visibleModalReturn && (
                <AlertModal
                    titleModal="Información"
                    msgModal={msgModalReturn}
                    observer={observer}
                    onClose={onClose}
                    status="info"
                    labelBtnConfirm={"Ok"}
                />
            )}
        </CGE.Panel>
    )
}

const AnulationSubscriptionWithProvider = ({
    props

}) => (
    <SubscriptionsContextProvider>
        <AnulationSubscription
            props={props}
        />
    </SubscriptionsContextProvider>
);

export default AnulationSubscriptionWithProvider;